import React from 'react'
import { Ellipsis } from 'components'
import styled from '@emotion/styled'
import { colors } from 'style/theme'
import { useClipboard } from 'use-clipboard-copy'
import { Icon } from 'antd'
import { Input, Alert } from 'antd';

const Key = styled.div({
	fontSize: '0.9rem',
	display: 'grid',
	gridTemplateColumns: `auto 40px `,
  cursor: "pointer",
  margin: '0.9rem'
})

const CopyToClipboard = styled(Icon)({
	fontSize: '1rem',
  color: colors.brandTextLight,
  margin: "0.2em"
})

const CopyToClipboardMessage = styled.div({
  fontSize: '0.6rem',
	fontWeight: 700,
	textTransform: 'uppercase',
	color: colors.brandTextLight
})

const ApiKeyModal = ( {handleKeyNameChange, generatedKeyName , generatedKey} ) => {
  const clipboard = useClipboard({ copiedTimeout: 600 })
	const handleClick = React.useCallback(() => {
		clipboard.copy(generatedKey)
	}, [clipboard, generatedKey])
  return (
    <>
    <Input 
    placeholder="Please enter key name"
    value={generatedKeyName}
    onChange={handleKeyNameChange}
    />
    <Key type="copy" onClick={handleClick}>
			<Ellipsis width={'100%'}>
       {generatedKey}
			</Ellipsis>
      <CopyToClipboardMessage>{clipboard.copied ? 'Copied' : <CopyToClipboard type="copy" />}</CopyToClipboardMessage>
    </Key>
    <Alert message="Make sure to copy the key now. You won't be able to see it again!" type="error" />
    </>
  )
}

export default ApiKeyModal